var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTentacleWhereBuySection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 972,
    viewBox: "0 0 208 972",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_664_7443",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 208,
    height: 972
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 972,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_664_7443)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_7443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.703 560.331C191.136 553.326 382.121 402.157 393.191 429.566C419.729 495.244 252.921 610.042 236.542 693.794C224.457 755.554 304.376 871.178 347.186 927.656L438.839 901.329C445.637 890.135 449.043 878.404 445.802 867.12C433.373 823.852 304.039 763.748 443.042 554.059C486.547 488.43 520.537 365.568 410.303 334.378C340.016 314.488 242.599 382.551 218.504 417.819C183.406 469.185 71.9703 455.286 174.944 382.464C216.496 353.075 245.681 329.28 261.961 301.089C301.975 231.805 270.761 183.437 216.264 160.938C184.104 147.666 173.999 125.061 168.283 92.992C154.626 16.3404 150.088 28.8118 145.223 11.8757L142.585 34.7201C142.585 34.7201 134.564 -24.2204 127.556 68.8872C122.522 135.854 200.844 179.176 188.726 263.248C176.599 347.322 28.6691 357.325 36.12 436.075C43.5709 514.824 114.27 567.335 152.701 560.323L152.703 560.331Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4436 566.333C286.461 628.265 283.794 472.947 340.16 493.165C396.526 513.384 255.224 565.249 191.845 696.594C133.341 817.829 197.091 918.818 212.551 947.49C215.606 953.155 220.68 958.042 227.222 962.116L356.322 925.032C340.117 887.639 317.362 826.056 313.314 767.477C306.907 674.785 328.293 640.868 351.713 601.517C406.904 508.784 490.64 464.811 427.869 409.491C376.205 363.959 301.131 461.067 265.097 494.027C229.063 526.988 122.321 507.373 110.199 429.966C98.0764 352.558 210.291 359.947 234.516 274.024C253.45 206.884 199.955 174.374 172.015 146.655C144.203 119.064 145.97 82.089 148.816 58.0309C151.73 33.43 147.955 -25.6426 121.904 32.2994C98.2685 84.8644 101.265 101.191 110.655 133.882C120.046 166.573 173.807 194.664 173.855 230.039C173.903 265.413 113.623 288.109 55.2369 349.685C-28.0456 437.526 16.7306 545.161 85.4436 566.333Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.703 560.331C191.136 553.326 382.121 402.157 393.191 429.566C419.729 495.244 252.921 610.042 236.542 693.794C224.457 755.554 304.376 871.178 347.186 927.656L438.839 901.329C445.637 890.135 449.043 878.404 445.802 867.12C433.373 823.852 304.039 763.748 443.042 554.059C486.547 488.43 520.537 365.568 410.303 334.378C340.016 314.488 242.599 382.551 218.504 417.819C183.406 469.185 71.9703 455.286 174.944 382.464C216.496 353.075 245.681 329.28 261.961 301.089C301.975 231.805 270.761 183.437 216.264 160.938C184.104 147.666 173.999 125.061 168.283 92.992C154.626 16.3404 150.088 28.8118 145.223 11.8757L142.585 34.7201C142.585 34.7201 134.564 -24.2204 127.556 68.8872C122.522 135.854 200.844 179.176 188.726 263.248C176.599 347.322 28.6691 357.325 36.12 436.075C43.5709 514.824 114.27 567.335 152.701 560.323L152.703 560.331Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4436 566.333C286.461 628.265 283.794 472.947 340.16 493.165C396.526 513.384 255.224 565.249 191.845 696.594C133.341 817.829 197.091 918.818 212.551 947.49C215.606 953.155 220.68 958.042 227.222 962.116L356.322 925.032C340.117 887.639 317.362 826.056 313.314 767.477C306.907 674.785 328.293 640.868 351.713 601.517C406.904 508.784 490.64 464.811 427.869 409.491C376.205 363.959 301.131 461.067 265.097 494.027C229.063 526.988 122.321 507.373 110.199 429.966C98.0764 352.558 210.291 359.947 234.516 274.024C253.45 206.884 199.955 174.374 172.015 146.655C144.203 119.064 145.97 82.089 148.816 58.0309C151.73 33.43 147.955 -25.6426 121.904 32.2994C98.2685 84.8644 101.265 101.191 110.655 133.882C120.046 166.573 173.807 194.664 173.855 230.039C173.903 265.413 113.623 288.109 55.2369 349.685C-28.0456 437.526 16.7306 545.161 85.4436 566.333Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.846 963.66L249.16 955.814C261.591 942.811 264.571 917.112 255.095 891.32C243.259 859.108 216.481 838.959 195.298 846.323C174.106 853.689 166.525 885.774 178.363 917.995C187.296 942.298 204.724 959.727 221.846 963.66Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.269 896.325C243.708 913.855 239.589 931.313 228.051 935.316C216.524 939.325 201.958 928.363 195.52 910.833C189.081 893.303 193.2 875.846 204.737 871.842C216.265 867.834 230.83 878.795 237.277 896.323L237.269 896.325Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.717 761.356C233.266 727.948 214.396 701.633 192.568 702.581C170.741 703.529 154.222 731.381 155.673 764.789C157.124 798.197 175.995 824.512 197.822 823.564C219.65 822.616 236.168 794.764 234.717 761.356Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.753 761.744C217.302 779.928 208.111 794.79 196.223 794.942C184.335 795.094 174.248 780.472 173.699 762.287C173.15 744.103 182.341 729.241 194.229 729.089C206.117 728.937 216.204 743.56 216.753 761.744Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.132 656.577C262.456 631.98 266.211 606.641 255.52 599.98C244.828 593.319 223.739 607.859 208.415 632.455C193.091 657.052 189.336 682.391 200.027 689.052C210.719 695.713 231.808 681.173 247.132 656.577Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.921 647.874C225.525 661.221 214.072 668.986 208.34 665.219C202.608 661.452 204.769 647.587 213.166 634.24C221.563 620.893 233.016 613.127 238.748 616.895C244.477 620.654 242.318 634.527 233.921 647.874Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.269 503.16C231.16 500.496 250.612 507.28 251.712 518.306C252.812 529.333 235.149 540.426 212.258 543.091C189.368 545.755 169.916 538.971 168.816 527.945C167.716 516.918 185.379 505.825 208.269 503.16Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.849 516C222.302 514.549 232.887 518.242 233.488 524.239C234.09 530.235 224.475 536.277 212.019 537.721C199.566 539.172 188.982 535.479 188.38 529.482C187.778 523.486 197.393 517.444 209.849 516Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.484 549.647C239.578 544.833 257.987 547.176 259.597 554.892C261.208 562.608 245.41 572.767 224.316 577.581C203.222 582.395 184.814 580.052 183.203 572.336C181.593 564.62 197.39 554.461 218.484 549.647Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.971 561.268C231.448 558.644 241.464 559.927 242.336 564.118C243.21 568.318 234.617 573.842 223.141 576.466C211.664 579.09 201.647 577.807 200.775 573.616C199.901 569.416 208.494 563.892 219.971 561.268Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.487 481.892C160.261 487.989 173.732 503.782 169.588 517.161C165.436 530.543 145.235 536.445 124.461 530.348C103.687 524.251 90.2165 508.458 94.3609 495.079C98.513 481.697 118.713 475.795 139.487 481.892Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.393 492.7C146.693 496.022 154.026 504.61 151.767 511.893C149.508 519.176 138.514 522.384 127.217 519.07C115.917 515.748 108.584 507.16 110.843 499.876C113.101 492.593 124.095 489.386 135.393 492.7Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.018 537.552C157.703 541.923 171.99 556.252 168.938 569.559C165.877 582.868 146.638 590.121 125.953 585.75C105.268 581.38 90.9804 567.051 94.0331 553.744C97.0935 540.435 116.333 533.181 137.018 537.552Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.828 548.357C145.081 550.738 152.859 558.534 151.193 565.771C149.53 573.016 139.061 576.953 127.802 574.583C116.548 572.203 108.77 564.406 110.436 557.169C112.1 549.924 122.568 545.987 133.828 548.357Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.902 440.984C117.009 460.757 109.432 479.615 94.9775 483.119C80.5235 486.624 64.67 473.434 59.5632 453.661C54.4564 433.888 62.0341 415.03 76.4881 411.526C90.9421 408.022 106.796 421.212 111.902 440.984Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8407 443.22C102.616 453.981 98.497 464.24 90.6322 466.142C82.7674 468.044 74.1399 460.874 71.3644 450.113C68.5889 439.352 72.7081 429.094 80.5729 427.192C88.4377 425.289 97.0651 432.46 99.8407 443.22Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.084 553.587C95.9474 544.264 93.5916 523.7 79.8221 507.655C66.0526 491.611 46.0836 486.162 35.2202 495.486C24.3567 504.809 26.7125 525.373 40.4821 541.417C54.2516 557.462 74.2205 562.91 85.084 553.587Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7573 515.119C78.1199 523.956 79.165 535.081 73.0847 539.958C67.0143 544.84 56.1189 541.626 48.7562 532.789C41.3936 523.952 40.3485 512.827 46.4288 507.95C52.4993 503.068 63.3946 506.282 70.7573 515.119Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2281 456.713C52.972 438.057 42.525 423.075 29.8943 423.248C17.2636 423.422 7.23199 438.686 7.48817 457.341C7.74435 475.996 18.1913 490.979 30.822 490.805C43.4527 490.632 53.4843 475.368 53.2281 456.713Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8515 456.676C42.8363 466.827 37.2561 474.948 30.3783 474.823C23.5005 474.698 17.9429 466.363 17.9505 456.215C17.9656 446.064 23.5459 437.943 30.4237 438.068C37.3014 438.193 42.859 446.527 42.8515 456.676Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.261 389.076C110.796 404.76 94.7488 412.342 83.4215 406.005C72.0941 399.669 69.7656 381.822 78.228 366.131C86.6926 350.447 102.74 342.865 114.068 349.201C125.395 355.538 127.723 373.385 119.261 389.076Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.217 383.346C105.609 391.877 96.8807 396.003 90.7184 392.559C84.5561 389.115 83.2927 379.397 87.8923 370.869C92.4996 362.338 101.228 358.212 107.391 361.656C113.553 365.1 114.816 374.818 110.217 383.346Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5013 386.809C55.0172 402.656 40.3258 411.144 30.6935 405.766C21.0611 400.387 20.1356 383.175 28.6197 367.328C37.1038 351.481 51.7951 342.993 61.4275 348.372C71.0598 353.75 71.9854 370.963 63.5013 386.809Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8537 381.865C51.2399 390.489 43.2409 395.104 38.0089 392.181C32.7671 389.253 32.2616 379.891 36.883 371.265C41.4968 362.641 49.4958 358.026 54.7278 360.949C59.9696 363.877 60.4751 373.239 55.8515 381.858L55.8537 381.865Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.478 350.331C146.562 359.073 131.051 358.463 124.825 348.959C118.6 339.455 124.026 324.669 136.932 315.922C149.848 307.18 165.359 307.789 171.585 317.293C177.811 326.798 172.385 341.583 159.478 350.331Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.785 342.23C147.757 346.988 139.317 346.656 135.93 341.485C132.543 336.313 135.496 328.266 142.516 323.51C149.544 318.751 157.984 319.083 161.371 324.255C164.758 329.426 161.805 337.473 154.785 342.23Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.017 337.39C93.607 347.058 78.8499 348.64 73.0542 340.922C67.2586 333.204 72.6177 319.11 85.0273 309.442C97.4369 299.775 112.194 298.193 117.99 305.911C123.785 313.629 118.426 327.723 106.017 337.39Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.652 330.723C94.9012 335.983 86.8705 336.845 83.713 332.646C80.5554 328.446 83.4747 320.774 90.2253 315.514C96.976 310.253 105.007 309.391 108.164 313.591C111.322 317.79 108.403 325.462 101.652 330.723Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.216 312.834C193.299 321.576 177.788 320.967 171.563 311.463C165.337 301.959 170.763 287.173 183.669 278.426C196.586 269.684 212.097 270.293 218.323 279.797C224.548 289.301 219.122 304.087 206.216 312.834Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.52 304.726C194.493 309.484 186.052 309.152 182.665 303.981C179.278 298.809 182.231 290.762 189.251 286.006C196.279 281.247 204.719 281.579 208.106 286.751C211.493 291.922 208.54 299.969 201.52 304.726Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.928 298.12C146.519 307.788 131.762 309.37 125.966 301.652C120.17 293.934 125.53 279.84 137.939 270.172C150.349 260.505 165.106 258.923 170.902 266.641C176.697 274.359 171.338 288.453 158.928 298.12Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.571 291.45C147.821 296.711 139.79 297.573 136.633 293.373C133.475 289.174 136.394 281.502 143.145 276.241C149.896 270.981 157.926 270.119 161.084 274.318C164.241 278.518 161.322 286.19 154.571 291.45Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.724 246.376C233.663 259 224.562 267.9 215.396 266.256C206.233 264.621 200.462 253.06 202.526 240.444C204.588 227.82 213.689 218.92 222.855 220.564C232.018 222.199 237.788 233.76 235.724 246.376Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.246 244.622C227.129 251.486 222.176 256.329 217.187 255.438C212.198 254.546 209.063 248.256 210.188 241.39C211.305 234.526 216.257 229.682 221.246 230.574C226.235 231.466 229.371 237.756 228.246 244.622Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.506 242.638C191.922 254.691 182.253 262.076 174.907 259.138C167.56 256.192 165.323 244.039 169.904 231.979C174.488 219.926 184.157 212.541 191.502 215.479C198.85 218.425 201.087 230.578 196.506 242.638Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.615 239.821C188.124 246.383 182.86 250.402 178.861 248.794C174.864 247.194 173.645 240.578 176.136 234.017C178.627 227.456 183.891 223.436 187.89 225.044C191.889 226.652 193.106 233.26 190.615 239.821Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.852 172.297C212.933 182.47 210.997 193.621 203.541 197.208C196.078 200.796 185.911 195.464 180.837 185.288C175.758 175.122 177.693 163.964 185.148 160.377C192.612 156.789 202.779 162.121 207.852 172.297Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.546 174.914C204.307 180.448 203.259 186.511 199.196 188.467C195.14 190.421 189.607 187.518 186.839 181.987C184.078 176.452 185.126 170.389 189.189 168.433C193.245 166.479 198.778 169.382 201.546 174.914Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.633 190.003C180.6 201.083 177.47 211.431 170.636 213.136C163.808 214.832 155.87 207.231 152.906 196.159C149.939 185.08 153.07 174.732 159.895 173.028C166.723 171.333 174.661 178.933 177.625 190.005L177.633 190.003Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.919 191.038C173.535 197.067 171.83 202.697 168.111 203.624C164.399 204.549 160.08 200.409 158.467 194.388C156.851 188.359 158.555 182.729 162.275 181.802C165.986 180.877 170.306 185.017 171.919 191.038Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.007 137.535C177.468 146.475 175.775 156.277 169.217 159.432C162.658 162.586 153.722 157.896 149.251 148.951C144.79 140.011 146.483 130.208 153.041 127.054C159.6 123.9 168.536 128.59 173.007 137.535Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.465 139.833C169.892 144.699 168.966 150.03 165.4 151.752C161.832 153.466 156.966 150.92 154.538 146.054C152.111 141.188 153.037 135.857 156.603 134.135C160.171 132.421 165.037 134.967 167.465 139.833Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.44 153.096C149.046 162.835 146.296 171.936 140.29 173.429C134.284 174.922 127.308 168.24 124.702 158.502C122.095 148.764 124.845 139.662 130.851 138.169C136.857 136.677 143.833 143.358 146.44 153.096Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.42 154.007C142.842 159.303 141.343 164.259 138.073 165.073C134.811 165.886 131.01 162.253 129.586 156.949C128.165 151.653 129.664 146.697 132.934 145.883C136.196 145.07 139.996 148.703 141.42 154.007Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.245 104.576C155.681 114.564 150.132 122.825 142.859 123.029C135.586 123.234 129.332 115.307 128.898 105.327C128.462 95.3386 134.01 87.0773 141.283 86.873C148.556 86.6686 154.81 94.5952 155.245 104.576Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.247 104.422C149.486 109.85 146.468 114.345 142.507 114.462C138.547 114.578 135.149 110.265 134.908 104.829C134.669 99.4011 137.687 94.9057 141.648 94.7893C145.608 94.673 149.006 98.9861 149.247 104.422Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64 107.961C123.049 117.917 116.829 125.109 110.739 124.027C104.649 122.945 100.999 113.997 102.582 104.043C104.173 94.0871 110.393 86.8948 116.483 87.9769C122.573 89.059 126.223 98.0076 124.64 107.961Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.682 106.745C118.821 112.157 115.43 116.079 112.121 115.485C108.804 114.893 106.824 110.023 107.686 104.611C108.547 99.1991 111.938 95.2776 115.247 95.8714C118.564 96.463 120.544 101.333 119.682 106.745Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.661 64.147C152.097 74.135 146.549 82.3962 139.275 82.6006C132.002 82.805 125.748 74.8784 125.314 64.898C124.878 54.91 130.426 46.6488 137.699 46.4444C144.972 46.24 151.227 54.1666 151.661 64.147Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.655 63.9955C145.894 69.4236 142.876 73.919 138.916 74.0354C134.955 74.1517 131.558 69.8386 131.316 64.4028C131.077 58.9747 134.095 54.4793 138.056 54.3629C142.016 54.2466 145.414 58.5597 145.655 63.9955Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.056 67.5327C119.448 77.4853 114.343 84.8634 109.648 84.0117C104.953 83.1601 102.447 74.406 104.055 64.4535C105.663 54.5009 110.768 47.1228 115.463 47.9744C120.158 48.8261 122.664 57.5801 121.056 67.5327Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.242 66.511C116.373 71.9253 113.59 75.9381 111.033 75.4769C108.476 75.0158 107.115 70.2503 107.984 64.836C108.861 59.4194 111.637 55.4089 114.194 55.87C116.751 56.3312 118.111 61.0967 117.242 66.511Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.824 901.333C445.622 890.139 449.043 878.403 445.802 867.12C433.373 823.852 304.039 763.748 443.042 554.059C482.874 493.969 514.708 385.917 435.191 344.159C455.081 360.358 464.263 383.103 468.816 403.259C486.758 482.69 431.204 543.951 384.111 606.135C322.447 687.55 330.772 773.447 434.191 902.664L438.824 901.333Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.006 440.334C127.276 430.216 134.869 410.806 174.944 382.464C216.496 353.075 245.683 329.288 261.961 301.089C293.829 245.91 280.518 203.991 246.24 177.852C275.241 214.325 264.076 263.242 251.237 289.714C223.004 347.95 162.61 358.631 131.278 397.872C123.01 408.226 121.768 437.52 135.004 440.327L135.006 440.334Z",
    fill: "#D16984"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_7443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481.153,
    height: 950.638,
    fill: "white",
    transform: "translate(-108.948 74.3083) rotate(-16.0268)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentacleWhereBuySection);
export default __webpack_public_path__ + "static/media/tentacle_where_buy_section.1431bd3ce2cd791c60f2033e6cc5729d.svg";
export { ForwardRef as ReactComponent };